import './assets/css/common.css'
import { i18n, loadLocaleMessages } from '@/i18n.js'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { store } from '@/stores/index.js'
import { appConfigurationStore } from '@/stores/appConfigurationStore.js'
import { tokenStore } from '@/stores/tokenStore.js'
import { configurationService } from '@/services/configuration.service'

import App from './App.vue'
import { router } from './router'


async function initApp() {
    const app = createApp(App)
    app.use(createPinia())
        
    app.config.globalProperties.$i18n = i18n
    
    app.config.globalProperties.$store = store()
    app.config.globalProperties.$appConfigurationStore = appConfigurationStore()
    app.config.globalProperties.$tokenStore = tokenStore()
    
    app.use(router)
    app.use(i18n)
    
    let params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
    })
    let translations = null
    if(await tokenStore().checkAndSaveToken(params.t)) {
        translations = await configurationService.getTranslations()
    } else {
        translations = configurationService.getStaticTranslations()
    }

    store().appTranslations = translations
    await loadLocaleMessages(translations)


    app.mount('#app')
  }
  
  initApp()
